import { imageUrl } from "@/utils/constants";

import FA_LANG from "@/assets/locale/fa";
import { QuizProps } from "./Test";
import ResponseInput from "./inputs/ResponseInput";
import { useId } from "react";

export default function ShortAnswer({
  selectedQuiz,
  updateQuizDetail,
  updateQuestion,
  addNewChoice,
  removeChoice,
  questionDirection,
}: QuizProps) {
  const handleQuestionChange = (value: string, i: number) => {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question: value,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  };

  function handleQuestionFileChange(image: any): void {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question_file: image,
      question_link: "",
      question_file_id: undefined,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  }
  function handleQuestionAudioChange(audio: any): void {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question_voice: audio,
      question_voice_link: undefined,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  }
  const image_id = useId();

  return (
    <div className="flex flex-col gap-8 items-start w-full">
      <ResponseInput
        inputValue={selectedQuiz.question}
        valueUpdated={handleQuestionChange}
        placeHolder={FA_LANG.QUESTION_INPUT}
        handleImageChange={handleQuestionFileChange}
        id={`file-input-question-test-${image_id}`}
        styleClass="h-[250px]"
        index={0}
        hasFile={true}
        imageUrl={
          selectedQuiz.question_link
            ? imageUrl + selectedQuiz.question_link
            : selectedQuiz.question_file
              ? URL.createObjectURL(selectedQuiz.question_file)
              : undefined
        }
        tabIndex={0}
        questionInput={true}
        questionDirection={questionDirection}
        handleVoiceChange={handleQuestionAudioChange}
        hasAudio={true}
        inputVoice={selectedQuiz.question_voice_link}
      />
      {/* <div className="flex flex-col justify-start items-start gap-[6px] flex-grow w-full">
        <div className="text-right text-[10px] font-medium leading-none"></div>

        <div className="flex items-start gap-4 flex-grow">
          <div className="flex flex-col justify-start items-start flex-grow self-stretch p-3">
            <div className="flex p-[6px] flex-col justify-center items-start gap-[6px] flex-grow self-stretch rounded-xl">
              <div className="flex justify-start items-center gap-[6px] self-stretch">
                <div className="flex flex-col justify-start items-end gap-3 w-fit">
                  <div className="text-right text-[20px] font-normal leading-7 text-text-caption">
                    {FA_LANG.SHORT_ANSWER_DESCRIPTION}
                  </div>
                </div>
                <div className="flex justify-center items-center gap-6 flex-grow">
                  <div className="relative flex justify-center items-start gap-6">
                    <div className="flex w-[120px] h-[120px] justify-center items-center">
                      {icons.forbidden}
                    </div>
                    <div className="absolute  flex w-[85.714px] h-[85.714px] left-[17.143px] top-[17.143px] justify-center items-center opacity-40">
                      {icons.score}
                    </div>
                  </div>
                </div>
                <div className="flex justify-center items-center gap-6 flex-grow">
                  <div className="relative flex justify-center items-start gap-6">
                    <div className="flex w-[120px] h-[120px] justify-center items-center">
                      {icons.forbidden}
                    </div>
                    <div className="absolute flex w-[85.714px] h-[85.714px] left-[17.143px] top-[17.143px] justify-center items-center opacity-40">
                      {icons.clock}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}
